<template>
<div class="card">
    <div class="card-body p-4">
        <div class="d-flex justify-content-between" v-if="user">
            <div class="d-flex mb-2">
                <span class="me-3 cursor-pointer" @click="showProfileImg(user.image)">
                    <img :src="absoluteUrl(user.image)" alt="user-image" class="rounded avatar-md" />
                </span>
                <span class="">
                    <h6 class="mb-1 mt-0">
                        {{user.first_name}} {{ user.middle_name }} {{ user.last_name }}
                    </h6>
                    <div class="text-muted small mb-1">
                        <i class="bx bxs-flag-alt me-1"></i>
                        <span >{{item.lga_name}} </span>
                    </div>
                </span>
            </div>
            <slot name="actions"></slot>
        </div>
        <hr class="my-2"/>
        <div class="">
            <div class="">
                <label class="small text-muted mb-1">Program Benefited</label>
                <div class="my-0" v-if="item.category">
                    {{ item.category.title }}
                </div>
            </div>
            <hr class="my-2"/>
            <div class="row">
                <div class="col-6">
                    <label class="small text-muted mb-1">Mobile</label>
                    <div class="my-0" v-if="user">
                        {{ user.mobile }}
                    </div>
                </div>
                <div class="col-6">
                    <div class="text-end">
                        <label class="small text-muted mb-1">Date registered</label>
                        <div class="" v-if="item.member"> <span class="badge bg-success"> {{ $filters.date(item.member.created_at)}}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props:{
        item:{
            type: Object,
            required: true
        }
    },
    computed:{
        user(){
            return this.item.member?.user
        }
    }
}
</script>

<style>

</style>